import React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { Button } from '@material-ui/core'
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

// import Navbar from '../components/Navbar';
import Navbar from '../components/NewNavbar';
import { Typography } from '@mui/material';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}))

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650
    },
    root: {
        display: 'flex',
        alignItems: 'center',
        width: 400
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1
    },
    iconButton: {
        padding: 10
    },
    divider: {
        height: 28,
        margin: 4
    },
    titleItemRight: {
        color: "white",
        backgroundColor: "blue",
        // height: 30,
        float: 'right',
        right: 16,
        bottom: '60px',
        position: "fixed",
        // transform: "translateY(-50%)"
    }
}))

const defaultTheme = createTheme()

const Location = () => {

    const classes = useStyles()

    return (
        // <>
        // <h1>Settings page...</h1>
        // </>
        <ThemeProvider theme={defaultTheme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />

                <Navbar />
                <Box
                    component='main'
                    sx={{
                        backgroundColor: theme =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto'
                    }}
                >
                    <Toolbar />
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, ml: 2, p: 1 }}>
                        {/* <Link underline="hover" color="inherit" href="/">
                                MUI
                            </Link> */}
                        <Link
                            underline="hover"
                            color="inherit"
                            to="/"
                        >
                            Home
                        </Link>
                        <Typography color="text.primary">Location</Typography>
                    </Breadcrumbs>
                    <Container maxWidth='xl' sx={{ mt: 1, mb: 3 }}>
                        <Grid container spacing={3}>
                            {/* SECTION #1 */}
                            {/* <Grid item xs={12} md={6} lg={6}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    Content #1
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // height: 240
                                    }}
                                >
                                    Content #2
                                </Paper>
                            </Grid> */}
                            <Grid item xs={12} md={12} lg={12}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '520px'
                                    }}
                                >
                                    Content #3
                                </Paper>
                            </Grid>
                            {/* <Box sx={{ '& > :not(style)': { m: 1 } }}>
                                <Fab size="small" color="secondary" aria-label="add" style={{ pull: 'right' }}>
                                    <AddIcon />
                                </Fab>
                            </Box> */}




                        </Grid>

                        <Fab size="small" color="secondary" className={classes.titleItemRight} aria-label="add">
                            <AddIcon />
                        </Fab>

                        {/* <Box className={classes.titleBar}> */}
                        {/* <Button variant="text" className={classes.titleItemRight}>
                                +
                            </Button> */}

                        {/* </Box> */}

                    </Container>

                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default Location;